import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { HelpComponent } from "./help/help.component";
import { ContactusComponent } from "./contactus/contactus.component";
import { AppComponent } from "./app.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { SyaratComponent } from "./syarat&ketentuan/syarat.component";
import { CookiePolicyComponent } from "./cookie-policy/cookie-policy.component";
import { FreeDeliveryBranchComponent } from "./free-delivery-branch/free-delivery-branch.component";
import { FreeDeliveryJakartaComponent } from "./free-delivery-jakarta/free-delivery-jakarta.component";
import { HomeComponent } from "./home/home.component";
import { RegisterComponent } from "./register/register.component";
import { RegisterCustomerComponent } from "./register/register-customer/registerCustomer.component";
import { WhySukandaOneLinkComponent } from "./why-sukanda-onelink/why.component";
import { WhatSukandaOneLinkComponent } from "./sukanda-onelink/what.component";
import { HowToUseSukandaOneLinkComponent } from "./how-to-use-sukanda-onelink/how.component";
import { TncComponent } from "./tnc/tnc.component";
import { KebijakanComponent } from "./kebijakan/kebijakan.component";
import { RegisterSalesComponent } from "./register/register-sales/register-sales.component";
import { TermConditionComponent } from "./termCondition/term-condition";
import { HubungiKamiComponent } from "./hubungi-kami/hubungiKami.component";
import { PanduanComponent } from "./panduan/panduan.component";
import { RegisterTrainingComponent } from './register/register-training/registerTraining.component';
import { RegisterTraining2Component } from "./register/register-training2/registerTraining2.component";
import { AbsensiComponent } from "./register/absensi/absensi";



const routes: Routes = [
  { path: "contact-us", component: ContactusComponent },
  { path: "help", component: HelpComponent },
  { path: "kebijakan-privasi", component: PrivacyPolicyComponent },
  { path: "syarat&ketentuan", component: SyaratComponent },
  { path: "cookie-policy", component: CookiePolicyComponent },
  { path: "free-delivery-branch", component: FreeDeliveryBranchComponent },
  { path: "free-delivery-jakarta", component: FreeDeliveryJakartaComponent },
  { path: "register-sales", component: RegisterSalesComponent },
  { path: "register-customer", component: RegisterCustomerComponent },
  { path: "register", component: RegisterCustomerComponent },
  { path: "register-training", component: RegisterTrainingComponent },
  { path: "register-training2", component: RegisterTraining2Component },
  { path: "absensi-training", component: AbsensiComponent},
  { path: "why-sukanda-onelink", component: WhySukandaOneLinkComponent },
  { path: "sukanda-onelink", component: WhatSukandaOneLinkComponent },
  { path: "how-to-use-sukanda-onelink", component: HowToUseSukandaOneLinkComponent },
  { path: "tnc", component: TncComponent },
  { path: "privacy-policy", component: KebijakanComponent},
  { path: "termCondition", component: TermConditionComponent},
  { path: "hubungi-kami", component: HubungiKamiComponent},
  { path: "bantuan", component: PanduanComponent},
  { path: "", component: HomeComponent }
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
